import React from 'react'
import { Link } from 'gatsby'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import Badge from './badge'
import useGetHomepageContent from '../hooks/useGetHomepageContent'

// IMAGES
import background from '../images/homepage/creator-bundle.png'
import image from '../images/homepage/creator-bundle-photo.png'
import guis from '../images/homepage/air-beta-product-guis.png'

// SVGS
import airiconoutline from '../images/svgs/air-logo-outline-white.svg'
import headphones from '../images/svgs/headphones-icon-black.svg'
import equalizer from '../images/svgs/equalizer-icon-black.svg'
import piano from '../images/svgs/piano-icon-black.svg'
import eye from '../images/svgs/eye-icon-black.svg'
import bag from '../images/svgs/bag-icon-black.svg'

export default function SubscribeAndSave() {
    const { subscribe_save, unlock_products } = useGetHomepageContent()
    return (
        <Container fluid style={{
            backgroundImage: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }}>
            <Container className='position-relative' style={{top: 48}}>
                <img src={airiconoutline} alt='' className='mw-100 mb-4 d-block mx-auto' />
                <h2 className='changeling-neo mb-5 text-center d-flex flex-wrap justify-content-center gap-3' style={{ fontSize: 48 }}>
                    <span>INSTRUMENT</span>
                    <span style={{ WebkitTextStrokeWidth: 1, WebkitTextFillColor: "rgba(0,0,0,0)" }}>EXPANSION PACK</span>
                </h2>
                
                <Row className='justify-content-center gap-md-5'>
                    <Col md='auto' className='position-relative'>
                        <img src={image} alt='' className='img-fluid shadow' style={{borderRadius: 16, border: '2px solid white'}} />
                        <Badge>LIMITED OFFER - SAVE 50% ON SUBSCRIPTIONS</Badge>
                    </Col>
                    <Col md={4} className='mt-5 mt-md-0'>
                        <div
                            className='mb-5 pb-5 mb-lg-0 pb-lg-0'
                            dangerouslySetInnerHTML={{ __html: subscribe_save }}
                        />
                    </Col>
                </Row>
            </Container>

            {/* <div dangerouslySetInnerHTML={{ __html: unlock_products }} /> */}
            <Container>
                <Row>
                    <Col className='text-center mb-5'>
                        <h3 className='text-uppercase fw-bold my-lg-5 pt-lg-5'>
                            UNLOCK OVER 50 products
                        </h3>
                        <div className='d-flex justify-content-between w-md-50 mx-auto my-5'>
                            <div>
                                <img src={headphones} alt='' />
                                <p className='m-0 mt-1 fw-semibold'>50,000 SOUNDS</p>
                            </div>
                            <div>
                                <img src={equalizer} alt='' />
                                <p className='m-0 mt-1 fw-semibold'>28 FX</p>
                            </div>
                            <div>
                                <img src={piano} alt='' />
                                <p className='m-0 mt-1 fw-semibold'>21 INSTRUMENTS</p>
                            </div>
                        </div>
                        <img src={guis} alt='' className='mw-100' />
                        <p className='w-md-50 mx-auto py-5' style={{fontSize: 14}}>
                            Unlock emotive powerful FX, multiple synthesis technologies, premium instrument samples, high-definition drums, vintage electric pianos, and a comprehensive groove-creation platform to provide today’s musician, composer, and producer with all the tools they need to make music.
                        </p>
                        <div className='d-inline-flex gap-3 mx-auto mb-5'>
                            <Link to='/subscriptions' className='btn bg-transparent border border-black flex-center gap-1 px-md-4 py-md-2'>
                                <img src={eye} alt='' />
                                DISCOVER PLANS
                            </Link>
                            <Link to='/subscriptions' className='btn flex-center gap-1 text-black bg-primary border border-primary px-md-4 py-md-2'>
                                <img src={bag} alt='' />
                                TRY FOR FREE
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    )
}